import { jsx as p } from "react/jsx-runtime";
import { T as u } from "../../chunks/title-banner.cY4BxAfL.js";
import { useSitecoreContext as c } from "@sitecore-jss/sitecore-jss-nextjs";
const n = ({
  rendering: e,
  className: l,
  fallbackTitle: m = { value: "Page Title" }
}) => {
  var i, s, a, r;
  const { sitecoreContext: t } = c(), o = (t == null ? void 0 : t.route) !== void 0;
  return /* @__PURE__ */ p(
    u,
    {
      title: o ? (s = (i = t.route) == null ? void 0 : i.fields) == null ? void 0 : s.pageTitle : m,
      description: o ? (r = (a = t.route) == null ? void 0 : a.fields) == null ? void 0 : r.pageShortDescription : void 0,
      isLarge: !1,
      dataTestId: e == null ? void 0 : e.componentName,
      className: l,
      withBreadcrumbs: !0
    }
  );
};
export {
  n as PageTitleBanner
};
